import { EasyClaimAppState, LocalizedCaseUrl } from 'src/easyclaim.api.client.typescript/src';
import { CustomerConfiguration } from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';
import { EasyClaimDocumentService } from 'src/easyclaim.app.services';

import { LogoImage } from '../../app/LogoImage';
import { UpdatedProgressBar } from '../UpdatedProgressBar/UpdatedProgressBar';

import styles from './styles/UpdatedHeader.module.css';
import { UpdatedLangChoose } from './UpdatedLangChoose';

const LANG_VISIBLE_STATES: Set<EasyClaimAppState> = new Set([
	EasyClaimAppState.Onboarding,
	EasyClaimAppState.OnboardingStart,
]);

const BG_COLOR_VISIBLE_STATES: Set<EasyClaimAppState> = new Set([
	EasyClaimAppState.OnboardingStart,
]);

interface UpdatedHeaderProps {
	caseId?: string;
	documentService?: EasyClaimDocumentService;
	currentLang: string;
	localizedCaseUrls?: LocalizedCaseUrl[] | null;
	caseState: EasyClaimAppState | undefined;
	showLanguageSelector?: boolean;
}

export const UpdatedHeader = ({
	caseId,
	documentService,
	currentLang,
	localizedCaseUrls,
	caseState,
	showLanguageSelector = true,
}: UpdatedHeaderProps) => {
	const config = CustomerConfiguration();

	if (!config) return null;

	const isOnboarding = caseState && BG_COLOR_VISIBLE_STATES.has(caseState);

	return (
		<header className={`${styles.header}${isOnboarding ? ` ${styles.onboardingHeader}` : ''}`}>
			{caseId && documentService && <LogoImage caseId={caseId} documentService={documentService} />}
			{showLanguageSelector && caseState && LANG_VISIBLE_STATES.has(caseState) && (
				<UpdatedLangChoose currentLang={currentLang} localizedCaseUrls={localizedCaseUrls} />
			)}
			<UpdatedProgressBar screen={caseState} frontendSteps={config.frontendSteps} />
		</header>
	);
};
